import Feed from "../../../components/feed";

const FeedPage = () => {
    return (
        <Feed />
    )
} 

export default FeedPage;